export const SEARCHFRIEND_START = 'SEARCHFRIEND_START';
export const SEARCHFRIEND_SUCCESS = 'SEARCHFRIEND_SUCCES';
export const SEARCHFRIEND_FAILURE = 'SEARCHFRIEND_FAILURE';

export const SEARCHFRIEND_RESET = 'SEARCHFRIEND_RESET';
